import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr1 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За електробезопасност при присъединяване на нов клиент или отстраняване на клиентски проблем
        в кабелната мрежа на А1 България ЕАД
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          Проверка за наличие на потенциал върху кабелната мрежа и крайните устройства свързани към
          нея.
        </b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        Проверява се със стандартен указател за напрежение (фазомер), като преди проверката се
        допира фаза (на контакт) след поява на светене е сигурно, че фазомерът работи нормално, след
        което допирате метален корпус на проверяваното крайно устройство или метална част на
        кабелната мрежа.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>Проверка на състояние на контакт</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Работи се със стандартен фазомер</b>, който има изолация по цялата дължина на
        отвертката.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Преди работа с фазомера </b>се докосва фазата на контакта за да се увери техника, че
        фазомера работи.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Проверява се защитното перо </b>(зануляването) на контакта със същия фазомер, за
        наличие на потенциал (напрежение).
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - ако фазомера светне, означава че контакта е офазен и работата се спира незабавно до
          отстраняване на повредата.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - ако фазомера не светне работата по проверката продължава - няма опасно напрежение на
          защитното перо.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Проверката се прави с една ръка</b> - с трите пръста се държи фазомера, а с четвъртия
        се докосва перото, което секунда преди това е проверено за висок потенциал. Фазомера е с
        изолирана отверка и осигурява 1 МΩ изолация на техника, което осигурява безопасността му.
      </Typography>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - ако не се увеличи светенето се спира инсталацията на клиента до осигуряване на защита на
          контакта.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body1" style={styles.whiteSpace}>
          <b>Измерване на напрежение между две галванично разделени части на кабелната мрежа</b>
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - измерва се с преносим волтметър - цифров, с обхват до 1000V.
        </Typography>
      </div>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        ИЗИСКВАНЕ КЪМ ТЕХНИЧЕСКИЯ ЕКИП :
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Техническият екип се състои от минимум двама техници, единият от които изпълнява ролята
          на ръководител екип (група). Със знанието на координатора/гл. техник или техническия
          супервайзор и запис в работния график, в зависимост от обема на работа и риска при
          работата, е възможно групата да се състои от един човек, при положение, че няма да се
          извършва инсталация или отстраняване на клиентски проблем при наличие на външна мрежа
          (въздушна или на фасада).
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Минималната квалификационна група по електробезопасност на техниците е трета. Допуска се
          единия от членовете на екипа да бъде с втора група, ако последния не извършва
          самостоятелна работа.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Всички техници трябва да бъдат запознати с настоящата инструкция срещу подпис.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Техниците трябва да бъдат оборудвани минимално със следното:
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Необходимите инструменти и материали за извършване на монтажните или ремонтни работи;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Работно облекло, обувки с нехлъзгащи се подметки, калцуни за обувките;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Стандартен фазомер, фазомер с дистанционно мерене, преносим волтметър и изолирани
          инструменти - клещи, отвертки;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Пробивни инструменти с двойна изолация (клас II) в изправно състояние и с изолирани
          ръкохватки;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Изправна преносима стълба за работа по фасади и вътрешни инсталации.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Абсолютно се забранява на техниците да събуват обувките си при влизане при абонат. При
          необходимост се използват калцуни поставени върху обувките.
        </Typography>
      </div>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        ВЪНШНИ ОПАСНИ НАПРЕЖЕНИЯ, КОИТО МОГАТ ДА ПОПАДНАТ В КАБЕЛНАТА МРЕЖА НА А1 БЪЛГАРИЯ ЕАД:
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. От електрическата инсталация на краен клиент:</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          а) При трипроводно захранване на крайни устройства - телевизионни приемници, компютри,
          усилвателни системи, мултимедийни проектори и др.
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При офазяване на контакт /230V на защитните пера/ (получава се при неправилно свързан
          контакт или при ремонт на сградна част или ел. табла, при който се разменят кабелите на
          фазата и нулата, при двупроводна мрежа, при която заземителните пера на контактите се
          използват за защита чрез зануляване), напрежение от 230V се подава на корпуса на
          захранваното съоръжение, а оттам през галванично свързания коаксиален кабел то се
          разпространява навсякъде по кабелната мрежа. Изключително опасна ситуация, защото няма
          късо съединение и предпазителите на ел. инсталацията не изгарят - напрежението се задържа
          за неопределено време, енергията е висока и всеки допир на човек (клиент или техник) до
          елемент, конектор, метална част на телевизионнен приемник, стационарен компютър от една
          страна и парно, водопровод, метален парапет и т.н. от друга може да доведе до фатален
          край;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При прекъсване на нулев проводник на ел. мрежата преди ел. контакта - ефекта е като в
          горния случай поради подаване на напрежение от 230V през консуматора, нулата на контакта,
          защитно перо на контакта, корпус на крайното устройство, а оттам по кабелната мрежа;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При захранване на ел. консуматори (телевизионни приемници, компютри и др.) от различни
          електрозахранващи системи (например съседни къщи, апартаменти и др.) напрежението на
          нулевия проводник, което е свързано чрез крайните консуматори и коаксиалния кабел към
          конекторите на кабелната мрежа може да е различно (нулите имат различни потенциали).
          Обикновено напрежението между нулевите проводници е до 10 V, но ако има аварии или лоши
          връзки в електрозахранващите инсталации, могат да станат и значително по-големи.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          б) При двупроводно захранване на крайни устройства - телевизори и цифрови приемници,
          компютри, системи за домашно кино, мултимедийни проектори и др.
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Външни напрежения по кабелната мрежа се получават при авария на крайни устройства -
          телевизионни и цифрови приемници, компютри и др. при което няма късо съединение и
          предпазителите на ел. инсталацията не изгарят - напрежението се задържа за неопределено
          време на цялата ТВ мрежа;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Външна ел. индукция до металните части на крайните устройства, пробиви във филтрови
          кондензатори водят до същия ефект.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Поява на външни напрежения, поради неправилно изтеглени коаксиални кабели:</b>
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        Ако коаксиалният кабел минава и се допира до елементи на сградните инсталации като:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Мълниезащитни токоотводи и заземители;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Неясни други заземителни системи;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Осветителни инсталации (включително метални окачени тавани);
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - Метални части където може да има външно напрежение, то коаксиалният кабел може да е
          източник на опасни напрежения. Особено внимание се обръща на заложените предварително
          кабелни трасета.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Напрежения получени отвън:</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При изтегляне на коаксиални кабелни трасета по стълбовете на електрозахранването или в
          канална мрежа, при авария е възможно поява на напрежение по коаксиалния кабел от
          електрозахранването на електроразпределителните дружества;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * От електрозахранващите табла на А1;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * От изтегляне на коаксиален кабел в сградата - от сградната инсталация
        </Typography>
      </div>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        ИНСТРУКЦИЯ ПО ЕЛЕКТРОБЕЗОПАСНОСТ ПРИ МОНТАЖ И ВКЛЮЧВАНЕ НА НОВ КЛИЕНТ
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Относно броя на телевизионни приемници и трасета на коаксиални кабели</b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Клиентът обявява броя на крайните устройства, които трябва да се свържат към мрежата -
          телевизионни приемници, компютри, системи за домашно кино и др.;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Клиентът съвместно с техниците определят трасето на свързващите коаксиални кабели;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При използване на съществуващи трасета (изградени от други кабелни оператори или
          изградени от клиента при ремонти или ново строителство) преди всичко друго се измерва
          потенциала на конекторите на коаксиалните кабели при присъединени и включени крайни
          устройства, след което, ако има потенциал, и при изключени и разкачени телевизионни
          приемници и други устройства, като се установява причината за поява на потенциал на
          коаксиалния кабел. При установяване на потенциал на коаксиалния кабел се работи с
          изолирани инструменти.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При изграждане на ново трасе при пробиване се разглежда мястото за наличие на
          силнотокови кабели, водопроводи или др. Работи се с изолационните дръжки на пробивните
          инструменти, като след направата на отвор се проверява визуално за коректността на отвора,
          а ако става въпрос за закрепване на кабела с метални крепежни елементи или към метални
          корпуси с фазомер се проверява наличие на потенциал на тях.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Внимава се трасетата на коаксиалните кабели да са на минимум 1 m от токоотводи на
          мълниезащитата на сградата.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          2. Относно проверка на електрическата инсталация на клиента свързана с настоящата
          инсталации:
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Проверява се състоянието на всички контакти, към които се свързват телевизионните и
          цифрови приемници, компютри, системи за домашно кино и др. Проверяват се и всички близко
          стоящи контакти.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Проверява се за наличие на нестандартни, нагорели, повредени удължители. Всички такива
          се отстраняват и се предупреждава клиента за състоянието им и опасностите от тях.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. Включване на клиентската мрежа към крайните устройства и свързване към външната
          инсталация.
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При нормално състояние на използваните контакти и удължители (липса на напрежение на
          защитни пера на контактите, корпуси на телевизионни приемници и компютри, както и наличие
          на защита от индиректен удар, зануляване) се пристъпва към присъединяване на клиентската
          мрежа, свързване с телевизори, компютри и др.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * След присъединяване на всички устройства и включване към захранващата ел. мрежа се
          проверява наличие на потенциал на сплитер (отклонител) или конектор от системата
          (независимо кой);
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Преди присъединяване към външната мрежа с преносим волтметър се измерва напрежението
          между конектора на вътрешната мрежа и сплитера (отклонитела) на външната мрежа.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При наличие на напрежение до 50V присъединяването може да се извърши но задължително с
          галваничен изолатор (протектор), на който допълнително се залепва знак за наличие на
          напрежение - жълт триъгълник с червена светкавица.{' '}
        </Typography>
      </div>
      <div>
        <b>
          <span style={styles.warning}>ВНИМАНИЕ</span> - при това присъединяване се работи само с
          изолирани инструменти (изолирани клещи). Ако техник хване галваничния изолатор с две ръце
          попада директно под напрежение. След присъединяването конекторите на галваничния изолатор
          се изолират с изолационна лента (изолирбант).
        </b>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При наличие на напрежение над 50V присъединяването не може да се извърши преди да се
          отстрани външното напрежение от мрежата.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При липса на напрежение присъединяването се извършва безопасно, но независимо от това се
          поставя галваничен изолатор (протектор). Целта на изолатора в този случай е при некоректна
          промяна на ситуацията от страна на клиента (разместване на устройства, мебели, удължаване
          на мрежата, ремонт на ел. инсталацията, свързване на други или допълнителни устройства)
          евентуалната поява на напрежение да се ограничи и да не се подава към други клиенти от
          една страна, а от друга, при поява на външно напрежение поради различни аварии, извън
          обекта, мрежата на клиента да е защитена. Конекторите на галваничния изолатор се изолират
          с изолирбанд, а корпуса на галваничния изолатор се заземява (ако има заземителна клема).
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * След присъединяване към външната кабелна мрежа, техникът трябва да демонстрира на
          клиента липсата на потенциали по крайните устройства и клиентската мрежа, като с фазомер
          се допре до конектор или сплитер (отклонител), а с другата си ръка се допре до парно,
          водопровод, метален парапет или до бетонна част. Задължително в Приемо-предавателния
          протокол се отразява, че екипът е оставил устройствата без напрежение на корпусите и с
          галваничния изолатор, като всяка поява на опасно напрежение във вътрешната мрежа е поради
          аварии на телевизионни приемници, компютри и др. или действие на клиента или свързани с
          него лица или фирми. Появата на напрежения от външната мрежа се пресича от галваничния
          изолатор.
        </Typography>
      </div>

      <Typography variant="subtitle1" style={styles.whiteSpace}>
        ИНСТРУКЦИЯ ПО ЕЛЕКТРОБЕЗОПАСНОСТ ПРИ ОТСТРАНЯВАНЕ НА КЛИЕНТСКИ ПРОБЛЕМ В МРЕЖАТА НА А1
        БЪЛГАРИЯ ЕАД
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        При клиентско посещение на екип на А1 България от гледна точка на електробезопасността се
        изпълняват следните дейности:
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. Чрез фазомер се проверяват отделните сплитери </b>(отклонители) или конектори за
        наличие на потенциал.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. При наличие на галваничен изолатор </b>чрез преносим волтметър са проверява за наличие
        на напрежение върху него;
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. При разкъсване на клиентската мрежа</b>, с цел локализиране на повредата, чрез
        преносим волтметър се проверява за наличие на напрежение между участъците;
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. При наличие на напрежение на вътрешната мрежа </b>
        последователността на действие е следната
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          <span style={styles.warning}>ВНИМАНИЕ</span> - в този случай се работи само с изолирани
          инструменти и диелектрични ръкавици!:
        </b>
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Проверява се за допълнително присъединени съоръжения и устройства, двупроводни
          удължители, ремонти в сградата или по ел. инсталацията;
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Отсъединяват се последователно прикачените устройства - телевизионни и цифрови
          приемници, компютри, системи за домашно кино и др.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * Ако след отстраняването и на последното устройство, продължава да има потенциал на
          мрежата се оглежда кабелното трасе за наличие на повреда или външни проводници около
          коаксиалния кабел. Особено внимание се отделя на скритите части на инсталацията и при
          преминаване над окачени тавани. Чрез секциониране се открива мястото на повредата.
        </Typography>
      </div>
      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          * При положение, че се установи, че крайно устройство - телевизионен или цифров приемник,
          компютър, връщат напрежение към клиентската мрежа, първо се проверява захранването - ел.
          контакт, удължител, а след това и крайното устройство, което или се дава на ремонт, или се
          подменя.
        </Typography>
      </div>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr1;
